import { type FormEvent, useEffect, useRef, useState } from 'react'
import { api } from '../api'
import { Fehlermeldung, fehlerText } from './gemeinsam'

export type MailLinkArt = 'einladung' | 'reset' | 'email'
export interface MailLinkDaten {
  art: MailLinkArt
  token: string
}

/** Liest einen Mail-Link (?einladung=, ?reset=, ?email=) und entfernt das Token sofort aus der Adresszeile. */
export function mailLinkAusUrl(): MailLinkDaten | null {
  const parameter = new URLSearchParams(window.location.search)
  for (const art of ['einladung', 'reset', 'email'] as const) {
    const token = parameter.get(art)
    if (token) {
      window.history.replaceState(null, '', window.location.pathname + window.location.hash)
      return { art, token }
    }
  }
  return null
}

export function MailLink({ link, onFertig }: { link: MailLinkDaten; onFertig: () => void }) {
  return link.art === 'email' ? <EmailBestaetigung token={link.token} onFertig={onFertig} /> : <PasswortSetzen link={link} onFertig={onFertig} />
}

function PasswortSetzen({ link, onFertig }: { link: MailLinkDaten; onFertig: () => void }) {
  const [passwort, setPasswort] = useState('')
  const [wiederholung, setWiederholung] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [fertig, setFertig] = useState(false)

  async function absenden(e: FormEvent) {
    e.preventDefault()
    setFehler(null)
    if (passwort !== wiederholung) return setFehler('Die Passwörter stimmen nicht überein.')
    try {
      if (link.art === 'einladung') await api.einladungAnnehmen(link.token, passwort)
      else await api.passwortZuruecksetzen(link.token, passwort)
      setFertig(true)
    } catch (err) {
      setFehler(fehlerText(err))
    }
  }

  if (fertig)
    return (
      <div className="anmeldung karte">
        <h1>Dolly</h1>
        <p>{link.art === 'einladung' ? 'Dein Zugang ist eingerichtet und deine E-Mail-Adresse bestätigt.' : 'Dein Passwort wurde geändert.'}</p>
        <button className="primaer" onClick={onFertig}>
          Zur Anmeldung
        </button>
      </div>
    )

  return (
    <form className="anmeldung karte" onSubmit={absenden}>
      <h1>Dolly</h1>
      <p>{link.art === 'einladung' ? 'Willkommen! Bitte vergib ein Passwort (mindestens 10 Zeichen).' : 'Neues Passwort vergeben (mindestens 10 Zeichen).'}</p>
      <label>
        Neues Passwort
        <input type="password" autoComplete="new-password" value={passwort} onChange={(e) => setPasswort(e.target.value)} autoFocus />
      </label>
      <label>
        Wiederholen
        <input type="password" autoComplete="new-password" value={wiederholung} onChange={(e) => setWiederholung(e.target.value)} />
      </label>
      <Fehlermeldung fehler={fehler} />
      <button type="submit" className="primaer" disabled={!passwort}>
        Passwort speichern
      </button>
      <button type="button" className="link" onClick={onFertig}>
        Abbrechen
      </button>
    </form>
  )
}

function EmailBestaetigung({ token, onFertig }: { token: string; onFertig: () => void }) {
  const [ergebnis, setErgebnis] = useState<{ ok: boolean; text: string } | null>(null)
  const gesendet = useRef(false)

  useEffect(() => {
    if (gesendet.current) return // Token ist nur einmal gueltig (StrictMode ruft Effekte doppelt auf)
    gesendet.current = true
    api
      .emailBestaetigen(token)
      .then(() => setErgebnis({ ok: true, text: 'Deine E-Mail-Adresse ist bestätigt.' }))
      .catch((e) => setErgebnis({ ok: false, text: fehlerText(e) }))
  }, [token])

  return (
    <div className="anmeldung karte">
      <h1>Dolly</h1>
      {ergebnis === null ? <p>E-Mail-Adresse wird bestätigt …</p> : ergebnis.ok ? <p>{ergebnis.text}</p> : <Fehlermeldung fehler={ergebnis.text} />}
      <button className="primaer" onClick={onFertig} disabled={ergebnis === null}>
        Weiter
      </button>
    </div>
  )
}
